import { render, staticRenderFns } from "./ReportSoftwareRelate.vue?vue&type=template&id=5455c9eb"
import script from "./ReportSoftwareRelate.vue?vue&type=script&lang=js"
export * from "./ReportSoftwareRelate.vue?vue&type=script&lang=js"
import style0 from "./ReportSoftwareRelate.vue?vue&type=style&index=0&id=5455c9eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports